import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { DatePickerComponent } from "Component/Custom";
import DynamicForm from "Component/DynamicForm";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { getEJ2CalenderDateFormat } from "Utils";
import { isIndateBeforeOutdate } from "Utils/dates";

const arrPriority = [
  {
    displayname: "Immediate",
    displayvalue: 1,
  },
  {
    displayname: "Moderate",
    displayvalue: 2,
  },
  {
    displayname: "Relaxed",
    displayvalue: 3,
  },
];

const styles = () => ({
  drawerPaper: {
    width: "30%",
    padding: 16,
  },
});

const jobstype = [
  {
    displayvalue: 1,
    displayname: "New hire",
  },
  {
    displayvalue: 2,
    displayname: "Replacement",
  },
];

class AddJobDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      flag: false,
      tempRequistionJobs: props.tempRequistionJobs,
      jobTemplates: [],
      jobs: [],
      positionCount: "",
      arremployeedata: [],
      hiredate: "",
      locations: [],
      locationId: "",
      employmentTypeId: "",
      employmenttypes: [],
      employeeId: "",
      employees: [],
      priorityId: "",
      priorities: [],
      allemployees: this.props.allemployees,
      startDate: "",
      endDate: "",
      hiringPipelines: [],
      pipelineId: "",
      selectedemployee: props.allemployees.filter((employee) =>
        props.tempRequistionJobs
          ? Array.isArray(props.tempRequistionJobs.outgoingemployees)
            ? props.tempRequistionJobs.outgoingemployees.some(
                (employeeids) => employeeids == employee.displayvalue,
              )
            : props.tempRequistionJobs.outgoingemployees
                .split(",")
                .some((employeeids) => employeeids == employee.displayvalue)
          : false,
      ),
    };
    this.handleChange = this.handleChange.bind(this);
    this.dateOnSelect = this.dateOnSelect.bind(this);
  }

  // componentDidMount() {

  // }

  //  const messagesEndRef = React.createRef();

  handleChange(key, value) {
    const tempRequistionJobs = this.state.tempRequistionJobs || {};
    if (key == "outgoingemployees") {
      tempRequistionJobs[key] = value && value.map((x) => x.displayvalue);
      tempRequistionJobs.availableposition = value && value.length;
      this.setState({ tempRequistionJobs, selectedemployee: value });
    } else {
      tempRequistionJobs[key] = value;
      this.setState({ tempRequistionJobs });
    }
  }

  UpdateSelectedEmpId(selectedItem) {
    this.setState({
      owneremployeeid: selectedItem ? selectedItem.displayvalue : null,
      SelectedEmpData: selectedItem,
    });
    // this.UpdateSelectedEmpId = this.UpdateSelectedEmpId.bind(this);
  }

  addJob = () => {
    const { tempRequistionJobs } = this.state;
    if (!tempRequistionJobs.jobtemplateid) {
      this.props.enqueueSnackbar("Please select job", { variant: "error" });
    } else if (!tempRequistionJobs.hiringtypeid) {
      this.props.enqueueSnackbar("Please select new hire or replacement", {
        variant: "error",
      });
    } else if (
      tempRequistionJobs &&
      tempRequistionJobs.hiringtypeid == 1 &&
      !tempRequistionJobs.availableposition
    ) {
      this.props.enqueueSnackbar(
        "Please enter how many positions are available",
        { variant: "error" },
      );
    } else if (
      tempRequistionJobs &&
      tempRequistionJobs.hiringtypeid == 2 &&
      this.state.selectedemployee.length == 0
    ) {
      this.props.enqueueSnackbar("Please select outgoing employee(s)", {
        variant: "error",
      });
    } else if (!tempRequistionJobs.hirebydate) {
      this.props.enqueueSnackbar("Please select Hire by date", {
        variant: "error",
      });
    } else if (!tempRequistionJobs.officeaddressids) {
      this.props.enqueueSnackbar("Please select reporting location", {
        variant: "error",
      });
    } else if (!tempRequistionJobs.employmenttypeid) {
      this.props.enqueueSnackbar("Please select outgoing employee(s)", {
        variant: "error",
      });
    } else if (!tempRequistionJobs.priorityid) {
      this.props.enqueueSnackbar("Please select priority", {
        variant: "error",
      });
    } else if (!tempRequistionJobs.pipelineid) {
      this.props.enqueueSnackbar("Please select pipeline", {
        variant: "error",
      });
    } else {
      this.props.updatePostData(tempRequistionJobs, true);
    }
  };

  dateOnSelect(event) {
    const startDate = event.startdate;
    const endDate = event.enddate;
    const isvalid = isIndateBeforeOutdate({
      indate: moment(),
      outdate: moment(startDate, "YYYY-MM-DD"),
    });
    if (isvalid) {
      const val = { startDate, endDate };
      this.setState({ selectedDate: val, ...val }, () => {
        this.GetWorkRequest(startDate);
      });
    } else {
      if (startDate && endDate) {
        this.props.enqueueSnackbar("Can not select today or past dates", {
          variant: "error",
        });
      }
      this.setState({ selectedDate: null });
    }
  }

  SelectHireDate(args) {
    const date = this.ConvertDate(args.value);
    const { tempRequistionJobs } = this.state;
    tempRequistionJobs.hirebydate = date;
    this.setState({ tempRequistionJobs });
  }

  ConvertDate = (str) => {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  };

  componentDidMount() {
    // this.getJobTemplate();
    // this.getPipelineList();
  }

  // getJobTemplate = () => {
  //   instance.get('recruit/getjobtemplatelist').then((result) => {
  //     this.setState({ jobTemplates: result.data.result });
  //   }).catch((error) => {
  //     this.props.enqueueSnackbar(
  //       error.response ? error.response.data.error.message : error.message,
  //       { variant: "error" },
  //     );
  //   });
  // }

  // getPipelineList = () => {
  //   instance.get('recruit/getpipelinelist').then((result) => {
  //     this.setState({ hiringPipelines: result.data.result });
  //   }).catch((error) => {
  //     this.props.enqueueSnackbar(
  //       error.response ? error.response.data.error.message : error.message,
  //       { variant: "error" },
  //     );
  //   });
  // }

  componentWillUnmount() {}
  // requisitionjobid: null,
  // jobtemplateid: null,
  // hiringtypeid: null,
  // availableposition: null,
  // hirebydate: null,
  // officeaddressids: null,
  // employmenttypeid: null,
  // priorityid: null,
  // pipelineid: null,

  render() {
    const { tempRequistionJobs } = this.state;
    return (
      <div>
        <DynamicForm
          fields={selectinputconverter({
            value: tempRequistionJobs && tempRequistionJobs.jobtemplateid,
            placeholder: "Select job",
            label: "Job",
            options:
              (this.props.initData && this.props.initData.jobTemplate) || [],
          })}
          onChange={(selectedid) => {
            this.handleChange("jobtemplateid", selectedid);
          }}
        />
        <DynamicForm
          fields={selectinputconverter({
            value: tempRequistionJobs && tempRequistionJobs.hiringtypeid,
            placeholder: "Select",
            label: "New hire or replacement?",
            options: jobstype,
          })}
          onChange={(selectedid) => {
            this.handleChange("hiringtypeid", selectedid);
          }}
        />
        {tempRequistionJobs && tempRequistionJobs.hiringtypeid == 1 && (
          <div>
            <DynamicForm
              fields={integerinputconverter({
                value:
                  tempRequistionJobs && tempRequistionJobs.availableposition,
                placeholder: "Enter number of position",
                label: "How many positions are available?",
                min: 1,
              })}
              onChange={(value) => {
                this.handleChange("availableposition", value);
              }}
            />
          </div>
        )}
        {tempRequistionJobs && tempRequistionJobs.hiringtypeid == 2 && (
          <div>
            <DynamicForm
              fields={multiselectinputconverter({
                value: this.state.selectedemployee,
                label: "Outgoing employee(s)",
                placeholder: "Select employee(s)",
                options: this.state.allemployees,
              })}
              onChange={(ids) => {
                this.handleChange("outgoingemployees", ids);
              }}
            />
            {/* <p className="extra-small-dark-secondary">
              3 positions will be shown as available
            </p> */}
          </div>
        )}

        <div>
          <p className="input-label">Hire by date</p>
          <DatePickerComponent
            placeholder="Select Date"
            id="startDate"
            allowEdit
            format={getEJ2CalenderDateFormat()}
            value={tempRequistionJobs && tempRequistionJobs.hirebydate}
            min={this.state.minApplyDate}
            change={this.SelectHireDate.bind(this)}
          />
        </div>
        <div className="margin-top-16">
          <DynamicForm
            fields={selectinputconverter({
              value: tempRequistionJobs && tempRequistionJobs.officeaddressids,
              placeholder: "Select location",
              label: "Reporting location",
              options:
                (this.props.initData && this.props.initData.officelocation) ||
                [],
            })}
            onChange={(selectedid) => {
              this.handleChange("officeaddressids", selectedid);
            }}
          />
        </div>
        <DynamicForm
          fields={selectinputconverter({
            value: tempRequistionJobs && tempRequistionJobs.employmenttypeid,
            placeholder: "Select type",
            label: "Employment type",
            options:
              (this.props.initData && this.props.initData.employmenttype) || [],
          })}
          onChange={(selectedid) => {
            this.handleChange("employmenttypeid", selectedid);
          }}
        />

        <DynamicForm
          fields={selectinputconverter({
            value: tempRequistionJobs && tempRequistionJobs.priorityid,
            placeholder: "Select priority",
            label: "Job priority",
            options: arrPriority,
          })}
          onChange={(selectedid) => {
            this.handleChange("priorityid", selectedid);
          }}
        />
        <div className="drawer-last-select">
          <DynamicForm
            fields={selectinputconverter({
              value: tempRequistionJobs && tempRequistionJobs.pipelineid,
              placeholder: "Select pipeline",
              label: "Hiring pipeline",
              options:
                (this.props.initData && this.props.initData.pipeline) || [],
            })}
            onChange={(selectedid) => {
              this.handleChange("pipelineid", selectedid);
            }}
          />
        </div>

        <Button
          className="btn btn-primary-md-blue margin-bottom-24"
          variant="contained"
          onClick={() => this.addJob()}
        >
          Add job
        </Button>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  login: state.AuthenticationAction.login,
});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(AddJobDrawer)),
);
